import { render, staticRenderFns } from "./NbButton.vue?vue&type=template&id=f5c744da&scoped=true&"
import script from "./NbButton.vue?vue&type=script&lang=js&"
export * from "./NbButton.vue?vue&type=script&lang=js&"
import style0 from "./NbButton.vue?vue&type=style&index=0&id=f5c744da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c744da",
  null
  
)

export default component.exports